import { create } from 'zustand';

type UseCrossingInfoBannerHasAtaTirChoice = {
  hasAta: boolean;
  hasTir: boolean;
  setHasAta: (hasAta: boolean) => void;
  setHasTir: (hasTir: boolean) => void;
};

export const useCrossingInfoBannerHasAtaTirChoice = create<UseCrossingInfoBannerHasAtaTirChoice>((set) => ({
  hasAta: false,
  hasTir: false,
  setHasAta: (hasAta: boolean) => set(() => ({ hasAta })),
  setHasTir: (hasTir: boolean) => set(() => ({ hasTir })),
}));
